import type { Reducer } from 'redux';
import type { PrintingGlobalSettings } from '@makemydeal/dr-dash-types';
import {
    UPLOAD_LOGO,
    GET_PRESIGNED_UPLOAD_URL_REQUEST,
    GET_PRESIGNED_UPLOAD_URL_SUCCESS,
    GET_PRESIGNED_UPLOAD_URL_FAILURE,
    CONFIRM_LOGO_UPLOAD_REQUEST,
    CONFIRM_LOGO_UPLOAD_SUCCESS,
    CONFIRM_LOGO_UPLOAD_FAILURE,
    DELETE_PRINTING_LOGO_REQUEST,
    DELETE_PRINTING_LOGO_SUCCESS,
    DELETE_PRINTING_LOGO_FAILURE,
    FETCH_PRINTING_LOGO_REQUEST,
    FETCH_PRINTING_LOGO_SUCCESS,
    FETCH_PRINTING_LOGO_FAILURE,
    SET_PRINTING_LOGO_CLIENT_ERROR,
    CLEAR_PRINTING_LOGO_ERROR
} from '../actionTypes/globalPrintingSettingsActionTypes';

const initialState: PrintingGlobalSettings = {
    logo: {
        logoUrl: '',
        isLoading: false,
        hasFetched: false,
        error: '',
        file: null,
        lastOp: null
    }
};

export type GlobalPrintingSettingsReducer = Reducer<PrintingGlobalSettings>;

export const reducer: GlobalPrintingSettingsReducer = (state = initialState, action) => {
    switch (action.type) {
        case UPLOAD_LOGO:
            return {
                ...state,
                logo: {
                    ...state.logo,
                    isLoading: true,
                    error: '',
                    lastOp: 'upload',
                    file: action.payload.metadata
                }
            };

        case DELETE_PRINTING_LOGO_REQUEST:
            return {
                ...state,
                logo: { ...state.logo, isLoading: true, error: '', lastOp: 'delete' }
            };

        case GET_PRESIGNED_UPLOAD_URL_REQUEST:
        case CONFIRM_LOGO_UPLOAD_REQUEST:
        case FETCH_PRINTING_LOGO_REQUEST:
            return { ...state, logo: { ...state.logo, isLoading: true, error: '' } };

        case GET_PRESIGNED_UPLOAD_URL_SUCCESS:
            return { ...state, logo: { ...state.logo, isLoading: true, error: '' } };

        case CONFIRM_LOGO_UPLOAD_SUCCESS:
            return {
                ...state,
                logo: {
                    ...state.logo,
                    logoUrl: action.payload?.logoUrl ?? '',
                    isLoading: false,
                    error: '',
                    file: action.payload?.logoMetadata ?? null
                }
            };

        case DELETE_PRINTING_LOGO_SUCCESS:
            return {
                ...state,
                logo: { ...state.logo, logoUrl: '', isLoading: false, error: '', file: null }
            };

        case FETCH_PRINTING_LOGO_SUCCESS:
            return {
                ...state,
                logo: {
                    ...state.logo,
                    logoUrl: action.payload?.logoUrl ?? '',
                    isLoading: false,
                    hasFetched: true,
                    error: '',
                    file: action.payload?.logoMetadata ?? null
                }
            };

        case GET_PRESIGNED_UPLOAD_URL_FAILURE:
        case CONFIRM_LOGO_UPLOAD_FAILURE:
        case DELETE_PRINTING_LOGO_FAILURE:
            return {
                ...state,
                logo: {
                    ...state.logo,
                    isLoading: false,
                    error: action.payload?.message ?? 'An error occurred'
                }
            };

        case FETCH_PRINTING_LOGO_FAILURE:
            return {
                ...state,
                logo: {
                    ...state.logo,
                    isLoading: false,
                    hasFetched: true,
                    error: action.payload?.message ?? 'An error occurred'
                }
            };

        case SET_PRINTING_LOGO_CLIENT_ERROR:
            return { ...state, logo: { ...state.logo, error: action.payload.message } };

        case CLEAR_PRINTING_LOGO_ERROR:
            return { ...state, logo: { ...state.logo, error: '' } };

        default:
            return state;
    }
};
